var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","width":"100%","justify-content":"flex-start","align-items":"center","flex-direction":"column"}},[_c('h1',[_vm._v("Privacy Policy for Skull King Counter")]),_c('p',[_vm._v("I do not collect any data from you, but google play needs this page anyway, so just enjoy the game")])])
}]

export { render, staticRenderFns }